/** Progress stages, in the order they appear as lanes inside a client zone. */
export const STAGES = ["planning", "not_started", "in_progress", "completed"];
export const STAGE_LABELS = {
    planning: "Planning",
    not_started: "Not started",
    in_progress: "In progress",
    completed: "Completed",
};
/**
 * Fixed sticky colour per stage, top to bottom down a client's column. Kept
 * here so the API, the UI and any export agree — the colour *is* the label, so
 * nothing else may decide it. Paper tones, not UI tones.
 */
export const STAGE_COLORS = {
    planning: "#b8d9f2",
    not_started: "#f4b3ad",
    in_progress: "#fbe08a",
    completed: "#b3e6b8",
};
export function isStage(value) {
    return typeof value === "string" && STAGES.includes(value);
}
//# sourceMappingURL=stages.js.map